export default __webpack_public_path__ + "static/media/loading2.c7d9f081.gif";